import { createSelector } from "reselect";
import { SelectOption } from "rivals/components/shared/Form/Select/types";
import { State as AppState, StateKeys } from "rivals/redux/reducer";
import { Position } from "rivals/shared/interfaces/Position";
import { MultiSelectType } from "rivals/shared/interfaces/search";
import { State } from "./reducer";

export const getPositionState = (state: AppState): State =>
  state[StateKeys.POSITION];

export const selectPositions = createSelector(
  getPositionState,
  state =>
    state.positions.map(
      (position: Position) =>
        ({
          name: position.name,
          value: position.id
        } as SelectOption<number>)
    ) || []
);

export const selectPositionAbbreviations = createSelector(
  getPositionState,
  state =>
    state.positions.map(
      (position: Position) =>
        ({
          name: position.abbreviation?.toUpperCase(),
          value: position.abbreviation?.toLowerCase()
        } as SelectOption<string>)
    ) || []
);

export const selectPositionOptions = createSelector(
  getPositionState,
  state =>
    state.positions.map(
      ({ abbreviation = "", name: label }): MultiSelectType => ({
        label,
        value: abbreviation?.toUpperCase()
      })
    ) || []
);
